import React, { FC } from 'react';
import * as translations from './strings';
import { getLangKey } from '../../../../../javascript/models/Language';
import { Button } from 'antd';
import styles from './index.module.css';
import cx from 'classnames';
import { ArrowRight } from 'lucide-react';
import { onArticleClick } from 'appJS/utils/HelpArticleButton';
import { View } from 'appJS/views/project_board/project_nav/types';
import { ActiveKey } from 'appJS/views/new_project_settings/types';

const strings = translations[getLangKey()];

export enum TaskListView {
  Feedback = 'feedback',
  Archive = 'archive'
}

type Props = {
  viewGuestKanban?: boolean;
  manageProject?: boolean;
  guestsSeeGuestsAllowed?: boolean;
  guestsSeeGuestsEnabled?: boolean;
  view: TaskListView;
};

const INVITE_INDEX = 1;
const PUBLIC_FEEDBACK_INDEX = 3;
const ACTION_INDEXES = [INVITE_INDEX, PUBLIC_FEEDBACK_INDEX];

export const navigateToProjectSettingsSidebarTab = (
  manageProject?: boolean
) => {
  if (!manageProject) return;
  // @ts-expect-error
  window.project_board_props?.setView(View.Settings);
  // @ts-expect-error
  window.project_board_props?.setActiveKey(ActiveKey.GuestPermissions);
};

const onClick = (manageProject?: boolean) => ({
  [INVITE_INDEX]: () => window.share_project_props?.openModal('client'),
  [PUBLIC_FEEDBACK_INDEX]: () =>
    navigateToProjectSettingsSidebarTab(manageProject)
});

const FeedbackDescription = ({
  manageProject,
  viewGuestKanban,
  guestsSeeGuestsAllowed,
  guestsSeeGuestsEnabled
}: {
  manageProject?: boolean;
  viewGuestKanban?: boolean;
  guestsSeeGuestsAllowed?: boolean;
  guestsSeeGuestsEnabled?: boolean;
}) =>
  viewGuestKanban ? (
    strings.feedbackYouLeave(
      !!(guestsSeeGuestsAllowed && guestsSeeGuestsEnabled)
    )
  ) : (
    <>
      {strings.hereYoullSee}{' '}
      {strings.haventAlready(!!manageProject).map((string, index) => {
        if (!ACTION_INDEXES.includes(index)) return string;
        return (
          <strong
            key={index}
            className={styles.actionText}
            onClick={onClick(manageProject)[index]}
          >
            {string}
          </strong>
        );
      })}
    </>
  );

export const EmptyState: FC<Props> = ({
  viewGuestKanban,
  manageProject,
  guestsSeeGuestsAllowed,
  guestsSeeGuestsEnabled,
  view
}) => {
  const title =
    strings[
      view === TaskListView.Feedback
        ? viewGuestKanban
          ? 'nothingHere'
          : 'quietInHere'
        : 'declutter'
    ];
  const description =
    view === TaskListView.Feedback ? (
      <FeedbackDescription
        manageProject={manageProject}
        viewGuestKanban={viewGuestKanban}
        guestsSeeGuestsAllowed={guestsSeeGuestsAllowed}
        guestsSeeGuestsEnabled={guestsSeeGuestsEnabled}
      />
    ) : (
      strings.archiveDescription
    );

  const article = view === TaskListView.Archive && (
    <Button
      type="text"
      className={styles.articleButton}
      href="https://support.bugherd.com/articles/11467195-chapter-5-managing-your-feedback-efficiently"
      onClick={() => onArticleClick({ articleId: 11467195 })}
    >
      {strings.managingFeedback}
      <ArrowRight className={styles.arrowIcon} />
    </Button>
  );

  return (
    <div className={styles.emptyState}>
      <div className={styles.messageContainer}>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.emptyStateDescription}>{description}</p>
        {article || null}
      </div>
      <div className={cx(styles.imageContainer, [styles[view]])} />
    </div>
  );
};
